<template>
    <div class="create_page_wrap">
        <div class="create_page_header" :style="{width: fixWidth}">
            <el-button type="text" icon="el-icon-back" :style="{fontSize: '14px'}" @click="closePage">返回</el-button>
            <span class="text pl10 pr10 font14px">|</span>
            <span class="text pr10 font14px">{{titleText}}工单</span>
            <el-button v-if="isView" type="primary" class="mr20" @click="closePage">关闭</el-button>
            <el-popover
                v-else
                placement="right-start"
                title="存在以下问题点，请检查修改后重试："
                width="400"
                trigger="manual"
                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                v-model="popoverVisible">
                <div class="tip-list">
                    <div style="max-height: 400px;overflow-y: auto;">
                        <p v-for="(item, index) in errorFormList" :key="index">
                            {{index+1}}、{{item}}；
                        </p>
                    </div>
                    <div class="btn tac mt10"><el-button @click="popoverVisible = !popoverVisible" type="primary" size="mini"><span>关闭</span></el-button></div>
                </div>
                <el-button slot="reference" :loading="submitLoading||pageLoading" type="primary" @click="submitData" >提交</el-button>
            </el-popover>
        </div>

        <div class="create_page_content">
            <div class="create_page_body p20" :loading="pageLoading">
                <div class="rejected_reason" v-if="rejectedReason&&isEdit">
                    <span class="text-color-error text-bold">上次驳回原因：</span> {{rejectedReason}}
                </div>
                <el-alert v-if="showProductNotice && !isView" class="product-notice" type="info" show-icon closable
                          title="工单现可关联产品（选填）：选择项目后，在“查看项目详情”中搜索或批量添加，支持跨媒体多选。"
                          @close="showProductNotice = false" />

                <el-form label-position="left" :model="formItem" ref="ruleForm" :rules="rules" label-width="120px">
                
                    <el-form-item prop="create_type" label="创建方式：">
                        <el-radio-group v-model="formItem.create_type" :disabled="isEdit" @change="changeCreateType">
                            <el-radio label="1">单独创建</el-radio>
                            <el-radio label="2">批量创建</el-radio>
                        </el-radio-group>
                        <p v-if="formItem.create_type=='2'" class="text-color-gray font12px">批量创建：所选项目统一应用所添加的需求明细，每一个项目为一个工单。</p>
                    </el-form-item>
                    <el-collapse v-model="collapseActiveNames">
                        <el-collapse-item title="工单信息" name="1">
                            <div style="margin-top:14px"/>
                            <el-form-item prop="project_list" label="项目名称：">
                                <template v-if="formItem.create_type=='2'">
                                    <ESelect
                                        ref="projectSelectMultiple"
                                        key="projectSelectMultiple"
                                        style="width: 400px;"
                                        :disabled="isEdit"
                                        :value="projectData"
                                        multiple
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        :remote-method="remoteProjectMethod"
                                        :loading="remoteProjectLoading"
                                        @change="changeProject"
                                        @remove-tag="removeProject"
                                        no-match-text="请前往 “信息管理-产品管理 ”中录入产品"
                                        no-data-text="请前往 “信息管理-产品管理 ”中录入产品"
                                        placeholder="请输入项目名称关键字搜索">
                                        <div slot="empty">
                                            <p class="m10 text-color-primary" v-if="remoteProjectLoading">
                                                <span class="el-icon-loading"></span>
                                            </p>
                                            <p class="m10 text-color-normal" v-else>未搜索到相关项目，请前往 “信息管理-客户产品管理 ”中先录入产品
                                                <span class="pointer text-color-primary" @click="toAppManagementPage">【立即前往】</span>
                                            </p>
                                        </div>
                                        <el-option
                                            v-for="item in projectOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </ESelect>
                                    <el-button type="primary" class="ml20" @click="showBatchProject" plain>批量录入</el-button>
                                </template>
                                <ESelect
                                    v-else
                                    ref="projectSelectSingle"
                                    key="projectSelectSingle"
                                    style="width: 400px;"
                                    :disabled="isEdit"
                                    v-model="projectId"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    :remote-method="remoteProjectMethod"
                                    :loading="remoteProjectLoading"
                                    @change="changeProject"
                                    @remove-tag="removeProject"
                                    no-match-text="请前往 “信息管理-产品管理 ”中录入产品"
                                    no-data-text="请前往 “信息管理-产品管理 ”中录入产品"
                                    placeholder="请输入项目名称关键字搜索">
                                    <div slot="empty">
                                        <p class="m10 text-color-primary" v-if="remoteProjectLoading">
                                            <span class="el-icon-loading"></span>
                                        </p>
                                        <p class="m10 text-color-gray" v-else>未搜索到相关项目，请前往 “信息管理-客户产品管理 ”中先录入产品
                                        <span class="pointer text-color-primary" @click="toAppManagementPage">【立即前往】</span>
                                        </p>
                                    </div>
                                    <el-option
                                        v-for="item in projectOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </ESelect>
                                <div class="project-info text-color-primary" v-if="projectDetailLoading">
                                    <span class="el-icon-loading"></span>
                                    <span class="font12px ml6">项目信息获取中，请稍等...</span>
                                </div>
                                <!-- <div class="project-info" v-else>
                                    <el-button type="text" class="text-color-error" v-if="hasProblemProject" @click="showProjectInfo">项目信息异常请点击补充</el-button>
                                    <el-button type="text" class="text-color-primary" v-else-if="formItem.project_list.length>0" @click="showProjectInfo">查看项目详情</el-button>
                                </div> -->
                            </el-form-item>
                            <el-form-item prop="material_type" label="素材类型：">
                                <el-radio-group v-model="tempData.material_type" @change="changeTempMaterialType" :disabled="isEdit">
                                    <el-radio label="1">图片</el-radio>
                                    <el-radio label="2">视频</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item prop="material_group" label="制作部门：" v-if="formItem.project_list.length>0">
                                <div class="material-group-wrap">
                                    <div class="group-item mb10" v-for="item in formItem.material_group" :key="item.app_type+item.game_classify">
                                        <div class="inline-block mr20 font12px text-color-form material-group-label">
                                            <span v-if="item.app_type=='1'">应用： </span>
                                            <span v-else-if="item.app_type=='2'">
                                                游戏-
                                                <span v-if="item.game_classify=='3'">IAA：</span>
                                                <span v-else-if="item.game_classify=='4'">IAP：</span>
                                                <span v-else>-</span>
                                            </span>
                                            <span v-else>-</span>
                                        </div>
                                        <ESelect v-model="item.group_id" @change="(val)=>changeMaterialGroup(val,item)" clearable filterable placeholder="请选择制作部门">
                                            <el-option
                                                v-for="inner in item.groupOptions"
                                                :key="inner.id"
                                                :label="inner.name"
                                                :value="inner.id">
                                            </el-option>
                                        </ESelect>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item prop="material_group" label="制作部门：" v-else>
                                <div class="font12px" style="color: #606266;">请选择项目后再选择制作部门</div>
                            </el-form-item>

                            <el-form-item prop="order_name" label="工单名称：">
                                <!--<el-input v-model.trim="formItem.order_name" placeholder="工单名称自动创建格式为【集团名称】-【项目名称】" style="width: 400px;"></el-input>-->

                                <!--@tab-click="data=>data.cb&&data.cb()"-->
                                <inputSelect
                                    placeholder="请输入工单名称或选择通配符自动创建"
                                    v-model="formItem.order_name"
                                    @change="changeOrderName"
                                    input-style="min-width:400px"
                                    :list="nameList"
                                />
                            </el-form-item>
                        </el-collapse-item>
                        <el-collapse-item title="任务明细" name="2">
                            <div style="margin-top:14px"/>
                                <el-table
                                    size="mini"
                                    :data="formItem.detail"
                                    stripe
                                    border
                                    :header-cell-style="{background:'#e8eaec',color:'#333',padding:0,}"
                                    :default-sort = "{prop: 'log_time', order: 'descending'}"
                                    class="mt4 full-w">
                                    <el-table-column
                                        prop="action"
                                        label="操作"
                                        align="center"
                                        width="100">
                                        <template slot-scope="scope">
                                            <span @click="addRow(scope.row,scope.$index)" class="el-icon-circle-plus pointer text-color-primary font16px ml2 mr2" title="添加一行"></span>
                                            <span @click="copyRow(scope.$index)" class="el-icon-document-copy pointer font16px ml2 mr2" title="复制"></span>
                                            <span v-if="isNotNeedConfirm(scope.row)" @click="deleteRow(scope.$index)" class="el-icon-remove pointer text-color-error font16px ml2 mr2" title="删除"></span>
                                            <el-popconfirm
                                                v-else
                                                title="您确定要删除吗？"
                                                confirm-button-text="删除"
                                                confirm-button-type="danger"
                                                @confirm="deleteRow(scope.$index)">
                                                <span slot="reference" class="el-icon-remove pointer text-color-error font16px ml2 mr2" title="删除"></span>
                                            </el-popconfirm>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="plat_id"
                                        label="媒体"
                                        align="center"
                                        width="100">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>媒体
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'plat_id'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="plat_id">
                                                    <ESelect v-model="scope.row.plat_id" @change="(val)=>changePlat(val,scope.$index)" filterable size="mini" class="full-w" placeholder="请选择">
                                                        <el-option
                                                            v-for="item in platList"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                            {{item.name}}
                                                        </el-option>
                                                    </ESelect>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="delivery_scene"
                                        label="投放场景"
                                        align="center"
                                        width="100">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>投放场景
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'delivery_scene'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="delivery_scene">
                                                    <ESelect v-model="scope.row.delivery_scene" @change="(val)=>changeDeliveryScene(val,scope.$index)" filterable size="mini" class="full-w" placeholder="请选择">
                                                        <el-option
                                                            v-for="item in scope.row.deliverySceneList"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                            {{item.name}}
                                                        </el-option>
                                                    </ESelect>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="delivery_type"
                                        label="投放版位"
                                        align="center"
                                        width="200">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>投放版位
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'delivery_type'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="delivery_type">
                                                    <el-cascader
                                                        placement="bottom-start"
                                                        :ref="'deliveryTypeCascader'+scope.$index"
                                                        size="mini"
                                                        class="mr20 full-w"
                                                        popper-class="cascader-mb20 cascader-x-scroll-auto cascader-list-height-204"
                                                        :value="scope.row.delivery_type"
                                                        :options="scope.row.deliveryTypeList"
                                                        :props="{value:'id',label:'name',expandTrigger: 'hover'}"
                                                        @change="(val)=>changeDeliveryType(val,scope.$index)"
                                                        clearable
                                                        filterable
                                                        placeholder="请选择">
                                                    </el-cascader>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="size"
                                        label="素材尺寸"
                                        align="center"
                                        width="250">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>素材尺寸
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" inline :ref="'detail'+scope.$index+'size'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="width">
                                                    <el-input-number size="mini" :controls="false" :value="scope.row.width" @change="(val)=>changeWidth(val,scope.$index)" :ref="'detailWidth'+scope.$index" style="width:70px;"></el-input-number> *
                                                </el-form-item>
                                                <el-form-item prop="height">
                                                    <el-input-number size="mini" :controls="false" :value="scope.row.height" @change="(val)=>changeHeight(val,scope.$index)" style="width:70px;"></el-input-number>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="material_format"
                                        label="素材格式"
                                        align="center"
                                        min-width="180">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>素材格式
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'material_format'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="material_format">
                                                    <ESelect :value="scope.row.material_format" @change="(val)=>changeFormat(val,scope.$index)" multiple filterable size="mini" class="full-w" placeholder="请选择">
                                                        <el-option value="all-option" v-if="!getOptionsAllChecked(scope.row,scope.$index,'material_format')">全选</el-option>
                                                        <el-option value="clear-option" v-if="getOptionsAllChecked(scope.row,scope.$index,'material_format')">取消全选</el-option>
                                                        <el-option
                                                            v-for="item in scope.row.formatList"
                                                            :key="item"
                                                            :label="item"
                                                            :value="item">
                                                            {{item}}
                                                        </el-option>
                                                    </ESelect>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="material_size_unit"
                                        label="素材大小"
                                        align="center"
                                        width="180">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>素材大小
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'material_size'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="material_size">
                                                    <el-input placeholder="素材大小" :value.number="scope.row.material_size" @input="(val)=>changeSize(val,scope.$index)" class="input-with-select" size="mini">
                                                        <el-button slot="prepend" size="mini">⩽</el-button>
                                                        <el-select :value="scope.row.material_size_unit" @change="(val)=>changeUnit(val,scope.$index)" slot="append" size="mini" placeholder="" style="width:70px;">
                                                            <el-option label="KB" value="KB"></el-option>
                                                            <el-option label="MB" value="MB"></el-option>
                                                        </el-select>
                                                    </el-input>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        v-if="formItem.material_type=='2'"
                                        prop="material_duration"
                                        label="素材时长"
                                        align="center"
                                        width="140">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>素材时长
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'material_duration'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="material_duration">
                                                    <el-input-number size="mini" :controls="false" v-model="scope.row.material_duration" @change="changeMaterialDuration" style="width:70px;"></el-input-number> 秒
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="material_num"
                                        label="需求数量"
                                        align="center"
                                        width="120">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>需求数量
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'material_num'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="material_num">
                                                    <el-input-number size="mini" :controls="false" v-model="scope.row.material_num" @change="changeMaterialNum" style="width:100px;"></el-input-number>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="label_ids"
                                        label="素材标签"
                                        align="center"
                                        min-width="180">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>素材标签
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'label_ids'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="label_ids">
                                                    <JtLabelCascader
                                                        :ref="'labelCascader'+scope.$index"
                                                        placement="bottom-start"
                                                        size="mini"
                                                        class="mr20 full-w"
                                                        popper-class="cascader-mb20 cascader-x-scroll-auto cascader-list-height-360"
                                                        :value="scope.row.label_ids"
                                                        :options="labelList"
                                                        :props="{value:'id',label:'name',emitPath:false,expandTrigger: 'hover',multiple:true,}"
                                                        :show-all-levels="false"
                                                        @change="(val)=>changeLabel(val,scope.$index)"
                                                        @remove-delete-tag="(tag)=>removeDeleteTag(tag,scope.$index)"
                                                        :deleteLabels="scope.row.delete_labels"
                                                        clearable
                                                        filterable
                                                        placeholder="请选择">
                                                    </JtLabelCascader>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="urgent_level"
                                        label="任务紧急程度"
                                        align="center"
                                        min-width="180">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>任务紧急程度
                                            <el-tooltip class="item" effect="dark" content="加急场景：图片当天下单当天完成；视频当天下单，第二天内完成的。" placement="top">
                                                <i class="el-icon-question"></i>
                                            </el-tooltip>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'urgent_level'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="urgent_level">
                                                    <ESelect v-model="scope.row.urgent_level" filterable size="mini" class="full-w" @change="changeUrgentLevel" placeholder="请选择">
                                                        <el-option
                                                            v-for="item in urgentLevelList"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                            {{item.name}}
                                                        </el-option>
                                                    </ESelect>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="expected_end_time"
                                        label="期望完成日期"
                                        align="center"
                                        min-width="180">
                                        <template slot="header">
                                            <span class="text-color-error pr4">*</span>期望完成日期
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form label-width="0" :ref="'detail'+scope.$index+'expected_end_time'" :model="scope.row" :rules="tableRules">
                                                <el-form-item prop="expected_end_time">
                                                    <el-date-picker
                                                        @change="changeExpectedEndTime"
                                                        v-model="scope.row.expected_end_time"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        :picker-options="pickerOptions"
                                                        size="mini"
                                                        style="width:160px"
                                                        placeholder="选择日期">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            <el-form-item prop="detail"></el-form-item>
                        </el-collapse-item>
                        <el-collapse-item title="其他信息" name="3">
                            <div style="margin-top:14px"/>
                            <el-form-item props="content" label="内容要求：">
                                <el-input v-model.trim="formItem.content" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="请输入素材中想要的内容" style="min-width: 400px;"></el-input>
                            </el-form-item>
                            <el-form-item props="avoid_content" label="避免要素：">
                                <el-input v-model.trim="formItem.avoid_content" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="请输入素材中避免的内容" style="min-width: 400px;"></el-input>
                            </el-form-item>
                            <el-form-item props="special_content" label="特殊备注：">
                                <div slot="label"><span class="text-color-error">特殊备注：</span></div>
                                <el-input v-model.trim="formItem.special_content" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="请输入制作时需要特别注意的地方" style="min-width: 400px;"></el-input>
                            </el-form-item>
                            <el-form-item props="attachment" label="附件上传：">
                                <div class="upload-box">
                                    <!--
                                    :before-upload="handleUpload"
                                    :on-success="handleSuccess"
                                    :on-error="handleError"
                                    :on-progress="handleProgress"
                                    :accept="fileAccept"
                                    -->
                                    <el-upload
                                        ref="upload"
                                        class="upload-btn"
                                        drag
                                        :http-request="fileRequest"
                                        :before-upload="handleUpload"
                                        :on-success="handleSuccess"
                                        :on-error="handleError"
                                        :on-progress="handleProgress"
                                        :before-remove="beforeRemove"
                                        :show-file-list="false"
                                        action="#"
                                        multiple>
                                        <div>
                                            <i class="el-icon-upload"></i>
                                            <div class="el-upload__text">上传文件</div>
                                            <div class="upload-loading-wrap" v-if="uploadLoading" title="素材正在上传中..."><i class="el-icon-loading"></i></div>
                                            <div class="stop-upload-wrap" v-if="uploadLoading" @click.stop="stopUploading">
                                                <el-link class="pointer text-color-error" type="danger">取消上传</el-link>
                                            </div>
                                        </div>
                                    </el-upload>
                                </div>
                                <div class="file-list">
                                    <el-tag
                                        class="mr10 pointer"
                                        v-for="file in formItem.attachment"
                                        :key="file.attachment_name"
                                        @close="beforeRemove(file)"
                                        @click="downloadFile(file)"
                                        disable-transitions
                                        closable>
                                        {{file.attachment_name}}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-collapse-item>
                    </el-collapse>
                </el-form>
            </div>
            <div class="p20 project_list" v-loading="projectDetailLoading">
                <!-- resetData -->
                <ProjectInfo ref="projectInfoRef" :data="formItem.project_list" :isEdit="isEdit" :isCopy="isCopy" />
            </div>
        </div>
        <!-- 产能预览弹框（仅黄/红提醒，不阻断下单） -->
        <capacity-preview-modal
            :visible="capacityPreview.visible"
            :water-list="capacityPreview.waterList"
            :recommend-date="capacityPreview.recommendDate"
            :worst-signal="capacityPreview.worstSignal"
            :category-group-name="capacityPreview.categoryGroupName"
            :judge-day="capacityPreview.judgeDay"
            :judge-is-workday="capacityPreview.judgeIsWorkday"
            :demand="capacityPreview.demand"
            :judge-ratio="capacityPreview.judgeRatio"
            @confirm="onCapacityConfirm"
            @cancel="onCapacityCancel" />
    </div>
</template>

<script>
    import { cloneDeep,uniq, debounce,find, difference } from 'lodash';
    import API from '@/api/workOrder/create.js';
    import { getCreateSchedulePreview } from '@/api/workOrder/scheduling.js';
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import FormGroup from './components/formGroup';
    import {projectInfoDrawer,submitTipModal, noAuthModal,batchProjectModal} from './modal/index';
    import dayjs from 'dayjs';
    import utils from '@/libs/utils.js';
    import { validEmoji, validHtml } from '@/utils/validate';
    import COS from '@/libs/cos/WorkOrder';
    import {JtLabelCascader } from '@/components/Ele';
    import { md5 } from 'js-md5';
    import matomoFun from "@/utils/matomo.js";
    import inputSelect from './components/inputSelect.vue';
    import ProjectInfo from './components/projectInfo.vue';
    import CapacityPreviewModal from './modal/capacityPreviewModal.vue';

    export default {
        name: "CreateIndex",
        components:{
            FormGroup,
            JtLabelCascader,
            inputSelect,
            ProjectInfo,
            CapacityPreviewModal,
        },
        props:{
            data:Object,
            type:String,
            query:{
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        data(){
            let _this = this;
            const validateProjectList = (rule, value, callback) => {
                let projectList = _this.formItem.project_list||[];
                if((_this.isEdit||_this.isCopy)&&_this.empty_project){
                    callback(new Error('项目下无产品，请删除后重新操作'));
                }else if (projectList.length<=0) {
                    callback(new Error('请选择项目'));
                }else if(Object.keys(this.$refs.projectInfoRef.errData).length>0){
                    callback(new Error('项目信息异常'));
                } else {
                    callback();
                }
            };
            const validateDetail = (rule, value, callback) => {
                let detailList = _this.formItem.detail||[];
                let errText = _this.checkDetailError(detailList);

                if(errText.length>0){
                    return callback(new Error(errText));
                }else{
                    let newList = cloneDeep(detailList).map(item=>''+item.plat_id+item.delivery_scene+(item.delivery_type||[]).join('')+item.width+item.height+item.material_size+item.material_duration +item.material_size_unit+item.material_format.join(',')+item.material_num+item.label_ids.join(',')+item.urgent_level+item.expected_end_time);
                    if(uniq(newList).length!=detailList.length){
                        return callback(new Error('任务明细存在重复项，请检查'));
                    }else{
                        callback();
                    }
                }

                /*if (detailData.length<=0) {
                    callback(new Error('请选择项目'));
                }else if(detailData.some(item=>!item.plat_id)){
                    callback(new Error('媒体不能为空，请修改后重新提交'));
                }else if(detailData.some(item=>!item.delivery_scene)){
                    callback(new Error('投放场景不能为空，请修改后重新提交'));
                }else if(detailData.some(item=>!item.delivery_type)){
                    callback(new Error('投放版位不能为空，请修改后重新提交'));
                }else if(detailData.some(item=>!item.width||!item.height)){
                    callback(new Error('素材尺寸不完整，请修改后重新提交'));
                }else if(detailData.some(item=>item.material_format.length<=0)){
                    callback(new Error('素材格式不能为空，请修改后重新提交'));
                }else if(detailData.some(item=>!item.material_size)){
                    callback(new Error('素材大小不能为空，请修改后重新提交'));
                }else if(detailData.some(item=>!item.material_num)){
                    callback(new Error('需求数量不能为空，请修改后重新提交'));
                }else if(detailData.some(item=>(item.label_ids||[]).length<=0)){
                    callback(new Error('素材标签不能为空，请修改后重新提交'));
                }else if(detailData.some(item=>!item.urgent_level)){
                    callback(new Error('任务紧急程度不能为空，请修改后重新提交'));
                }else if(detailData.some(item=>!item.expected_end_time)){
                    callback(new Error('期望完成日期不能为空，请修改后重新提交'));
                }else {
                    let expectedEndDateArr = detailData.map(item=>item.expected_end_time);
                    let nowDate = utils.formatDate(new Date(),'yyyyMMdd');
                    let isBeforeToday = expectedEndDateArr.some(item=>+item<+nowDate);
                    if(isBeforeToday){
                        callback(new Error('期望完成时间不可早于今天，请修改后重新提交'));
                    }else{
                        callback();
                    }
                }*/
            };
            const validateMaterialGroup = (rule, value, callback) => {
                let groupData = _this.formItem.material_group||[];
                if (groupData.length<=0) {
                    callback(new Error('请选择制作部门'));
                }if(groupData.some(item=>!item.group_id)){
                    callback(new Error('制作部门不能为空'));
                }else {
                    callback();
                }
            };
            const validContent = (rule, value, callback) => {
                if (validHtml(value) || validEmoji(value)||value.includes(' ')) {
                    callback(new Error('不能有特殊字符（<>?/{}”\\|‘;#¥%^&*+=），表情包，html'))
                }else {
                    callback()
                }
            };


            return {
                showProductNotice: true,
                capacityPreview: { visible: false, waterList: [], recommendDate: '', worstSignal: 'green', categoryGroupName: '', judgeDay: '', judgeIsWorkday: true, demand: 0, judgeRatio: 0 },
                // 超产能审批已下线（2026-07-10 起）·本字段**恒空**·仅为保持提交参数结构不变，勿再赋值
                overCapacityReason: '',
                collapseActiveNames:['1','2','3'],
                tags: [
                    {
                        value: '1',
                        label: '待指派'
                    }, {
                        value: '2',
                        label: '制作中'
                    }, {
                        value: '3',
                        label: '被驳回'
                    }, {
                        value: '4',
                        label: '已完成'
                    }, {
                        value: '5',
                        label: '已撤回'
                    }
                ],
                fixWidth: '1000px',
                popoverVisible:false,
                errorFormList:[],
                pageLoading:false,
                submitLoading:false,
                remoteProjectLoading:false,
                formItem:{
                    create_type:'1',    // 1-单独创建 2-批量创建
                    project_list:[],
                    project_id:'',
                    material_type:'1',
                    material_group:[],
                    order_name:'',
                    content:'',
                    avoid_content:'',
                    special_content:'',
                    detail:[],
                    attachment:[],
                },
                rules:{
                    create_type:[
                        { required: true, message: '请选择创建方式', trigger: 'blur' },
                    ],
                    project_list:[
                        { required: true, validator: validateProjectList, trigger: 'blur' },
                    ],
                    material_type:[
                        { required: true, message: '请选择素材类型', trigger: 'blur' },
                    ],
                    material_group:[
                        { required: true, validator: validateMaterialGroup, trigger: 'blur'},
                    ],
                    order_name:[
                        {required: true, message: '工单名称不可为空', trigger: 'blur' },
                        { max: 30, message: '工单名称最长支持30个字', trigger: 'blur' },
                        { validator: validContent, trigger: 'blur' },
                    ],
                    detail:[
                        { required: true, validator: validateDetail, trigger: 'blur'},
                    ],
                    content:[
                        { max: 500, message: '内容要求最长支持500个字', trigger: 'blur' },
                    ],
                    avoid_content:[
                        { max: 500, message: '避免要素最长支持500个字', trigger: 'blur' },
                    ],
                    special_content:[
                        { max: 500, message: '特殊备注最长支持500个字', trigger: 'blur' },
                    ],
                },
                tableRules:{
                    plat_id:[
                        { required: true, message: '请选择媒体', trigger: ['blur', 'change'], },
                    ],
                    delivery_scene:[
                        { required: true, message: '请选择', trigger: ['blur', 'change'], },
                    ],
                    delivery_type:[
                        { required: true, message: '请选择', type:'array', trigger: ['blur', 'change'], },
                    ],
                    width:[
                        { required: true, message: '请填写', trigger: ['blur'], },
                        { type:'integer', message: '输入整数', trigger: 'blur' },
                        { type:'number', max: 9999, message: '不能超过4位', trigger: 'blur' },
                        { type:'number', min: 1, message: '需大于0', trigger: 'blur' },
                    ],
                    height:[
                        { required: true, message: '请填写', trigger: ['blur'], },
                        { type:'integer', message: '输入整数', trigger: 'blur' },
                        { type:'number', max: 9999, message: '不能超过4位', trigger: 'blur' },
                        { type:'number', min: 1, message: '需大于0', trigger: 'blur' },
                    ],
                    material_format:[
                        { required: true, message: '请选择格式',type:'array', trigger: ['blur', 'change'], },
                    ],
                    material_size:[
                        { required: true, message: '请填写', trigger: ['blur'], },
                        { type:'integer', message: '输入整数', trigger: 'blur' },
                        { type:'number', max: 9999, message: '不能超过4位', trigger: 'blur' },
                        { type:'number', min: 1, message: '需大于0', trigger: 'blur' },
                    ],
                    material_num:[
                        { required: true, message: '请填写数量', trigger: ['blur'], },
                        { type:'integer', message: '输入整数', trigger: 'blur' },
                        { type:'number', max: 1000, message: '不能大于1000', trigger: 'blur' },
                        { type:'number', min: 1, message: '需大于0', trigger: 'blur' },
                    ],
                    label_ids:[
                        { required: true, message: '请选择标签',type:'array', trigger: ['blur', 'change'], },
                    ],
                    urgent_level:[
                        { required: true, message: '请选择', trigger: ['blur', 'change'], },
                    ],
                    expected_end_time:[
                        { required: true, message: '请选择', trigger: ['blur', 'change'], },
                    ],
                    material_duration:[
                        { required: true, message: '请填写时长', trigger: ['blur'], },
                        { type:'integer', message: '输入整数', trigger: 'blur' },
                        { type:'number', max: 999, message: '不能超过3位', trigger: 'blur' },
                        { type:'number', min: 1, message: '需大于0', trigger: 'blur' },
                    ],
                },
                projectOptions:[],
                groupOptions:[],
                uploadLoading:false,
                fileAccept:"image/png,image/gif",
                platList:[],
                labelList:[],
                urgentLevelList:[
                    {
                        id:'1',
                        name:'普通',
                    },
                    {
                        id:'2',
                        name:'加急',
                    },
                ],
                baseConfig:{
                    plat_id:'',
                    delivery_scene:'',
                    delivery_type:[],
                    width:undefined,
                    height:undefined,
                    material_format:[],
                    material_size:'',
                    material_size_unit:'KB',
                    material_duration:undefined,
                    material_num:undefined,
                    label_ids:[],
                    urgent_level:'1',
                    expected_end_time:'',
                    deliverySceneList:[],
                    deliveryTypeList:[],
                    formatList:[],
                },
                formatList:[],
                allProjectList:[],
                projectData:[],     // 临时存储选中的project
                projectId:'',       // 临时存储选中的project
                projectDetailLoading:false,
                fixedProjectError:false,
                submitSign:'',
                tempData:{
                    material_type:'1',
                },
                pickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() < Date.now()-1000*60*60*24*1;
                    },
                },
                rejectedReason:'',
                empty_project:false,
                uploadTaskList:[],
                buriedPointId:'',    // 埋点的ID
                nameList:[
                    {
                        label: '集团名称',
                        value: '集团名称',
                    },
                    {
                        label: '客户名称',
                        value: '客户名称',
                    },
                    {
                        label: '项目名称',
                        value: '项目名称',
                    },
                ],
            }
        },
        computed:{
            ...mapGetters(['sidebar']),
            id(){
                return (this.query||{}).order_id||(this.query||{}).id;
            },
            isView(){
                return this.query.actionType=='view';
            },
            isAdd(){
                return this.query.actionType=='add';
            },
            isCopy(){
                return this.query.actionType=='copy';
            },
            isEdit(){
                return this.query.actionType=='edit';
            },
            titleText(){
                if(this.isView) return '查看';
                if(this.isAdd) return '创建';
                if(this.isCopy) return '复制';
                if(this.isEdit) return '修改';
                return '创建';
            },
            hasProblemProject(){
                let projectList = this.formItem.project_list;
                if(projectList.length<=0) return false;
                /*type:
                *  -1-正常
                *  1-需要填写项目日预算
                *  2-多个产品，需要选择产品类型和游戏分类
                *  3-产品类型，游戏分类，项目日预算均需要填写
                *  4-无产品类型，游戏分类，但有项目日预算*/
                return projectList.some(item=>{
                    if(!item.package_type) return true;
                    if(item.type=='1'){
                        if(!item.avg_daily_cost) return true;
                    }
                    if(item.type=='2'){
                        if(!item.app_type) return true;
                        if(item.app_type=='2'&&!item.game_classify) return true;
                    }
                    if(item.type=='3'){
                        if(!item.app_type) return true;
                        if(item.app_type=='2'&&!item.game_classify) return true;
                        if(!item.avg_daily_cost) return true;
                    }
                    if(item.type=='4'){
                        if(!item.app_type) return true;
                        if(item.app_type=='2'&&!item.game_classify) return true;
                    }
                    return false;
                });
            },
            optionsAllChecked(){
                return this.projectOptions.map(item=>item.value).every(item=>this.projectData.includes(item));
            },
            isNeedConfirm(){
                let isNeedConfirm = false;
                if(this.formItem.create_type=='1'&&this.projectId){
                    isNeedConfirm = true;
                }else if(this.formItem.create_type=='2'&&this.projectData.length>0){
                    isNeedConfirm = true;
                }
                return isNeedConfirm;
            },
        },
        watch:{
            sidebar: {
                handler(){
                    setTimeout(this.getFixWidth, 300)
                },
                deep:true,
            },
            isNeedConfirm:{
                handler(val){
                    if(this.isAdd){
                        this.$store.commit('workOrder/UPDATE_CREATE_PAGE_STATUS', val);
                    }
                },
            },
            'titleText': {
                handler(val) {
                    let cur_name = ''
                    if(val) {
                        cur_name = `${val}工单`
                    }
                    this.CHANGE_BREADCRUMB(['工单管理', cur_name])
                },
                immediate: true
            },
        },
        mounted() {
            this.getFixWidth();
            this.getPlatList();
            this.getLabelConfig();

            if(this.isAdd) {
                this.formItem.order_name = '{集团名称}-{项目名称}';
                this.getMaterialFormat();
            }

            if(!this.id){
                this.setDefaultRow();
            }else {
                this.getOrderInfo().finally(()=>{
                    this.getMaterialFormat();
                });
            }
            window.addEventListener("resize", this.getFixWidth);
            window.onbeforeunload = function(){
                return "确定要离开吗？系统可能不会保存您所做的更改";
            }

            if(!this.isView){
                API.saveBuriedPoint({
                    steps:'1',      // 1-点击创建/修改时 2-触发弹窗时 3-最终提交时,
                    id:'',  // 创建id （第2、3步时传）
                    type:this.isEdit?'2':'1',      // 1-创建 2-修改
                    project_id:[],
                    click_type:'',  // 点击类型 1-去看看 2-继续提交（点了关闭弹窗此参数为空）
                    order_id:'',
                }).then(res=>{
                    let resData = res.data;
                    console.log('saveBuriedPoint',res);
                    if(typeof resData == "string" ){
                        this.buriedPointId = resData;
                    }
                });
            }
        },
        methods:{
            ...mapActions('workOrder', ['READ_ROUTE_LIST']),
            ...mapMutations('app', [
                'CHANGE_BREADCRUMB',
            ]),
            getFixWidth(){
                let $createBody = document.querySelector('.create_page_content');
                this.fixWidth = `${$createBody.clientWidth}px`;
            },
            pushMatomo(name) {
                let cur_name = find(this.tags, item=>item.value == this.query.tagsActive)
                let behaviorCategory = `素材工单(工单管理-${cur_name?.label})`
                matomoFun.trackEvent(behaviorCategory, '点击', name)
            },
            closePage(){
                if(this.isNeedConfirm&&this.isAdd){
                    this.$confirm('您确定要离开吗？', '温馨提示', {
                        confirmButtonText: '离开',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.pushMatomo(this.titleText + '工单(返回)')
                        if(window.history.length > 1) {
                            this.$router.go(-1)
                        }else{
                            this.$router.replace({
                                name:'work_order_material',
                                query: {
                                    topage: 'MaterialPage',
                                    tagsActive: this.query.tagsActive ? this.query.tagsActive.toString() : '1',

                                },
                                params:{
                                    menuReload: 1
                                }
                            });
                        }
                    }).catch(() => {
                    });
                }else{
                    this.pushMatomo(this.titleText + '工单(返回)')
                    if(window.history.length > 1) {
                        this.$router.go(-1)
                    }else{
                        this.$router.replace({
                            name:'work_order_material',
                            query: {
                                topage: 'MaterialPage',
                                tagsActive: this.query.tagsActive ? this.query.tagsActive.toString() : '1',
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                    }
                }
            },
            getPlatList(){
                API.getPlatList().then(res=>{
                    this.platList = (res.data||[]).map(item=>{
                        return {
                            id:item.plat_id,
                            name:item.plat_name,
                        }
                    })
                })
            },
            getMaterialFormat(){
                return new Promise((resolve,reject)=>{
                    API.getMaterialFormat({
                        type:this.formItem.material_type,
                    }).then(res=>{
                        console.log('getMaterialFormat',res);
                        this.formatList = res.data||[];
                    }).finally(()=>{
                        // this.getOrderInfo()
                    })
                })

            },
            async getMaterialFormat1(){
                await API.getMaterialFormat({
                    type:this.formItem.material_type,
                }).then(res=>{
                    console.log('getMaterialFormat1',res);
                    this.formatList = res.data||[];
                })
            },
            changeCreateType(val){
                console.log('changeCreateType',val);
                if(val=='1'){
                    this.projectId = this.projectData[0]||'';
                    this.projectData = [];
                    this.formItem.project_list =  this.formItem.project_list.filter(item=>item.project_id==this.projectId);
                    this.projectOptions = this.allProjectList.filter(item=>item.value==this.projectId);

                    this.formItem.material_group = this.formItem.material_group.filter(item=>{
                        let project = this.formItem.project_list[0];
                        if(item.app_type=='1'&&item.app_type==project.app_type) return true;
                        if(item.app_type=='2'&&item.app_type==project.app_type&&item.game_classify==project.game_classify) return true;
                        return false;
                    })
                    this.changeProject(this.projectId);
                }else if(val=='2'){
                    this.projectData = this.projectId?[this.projectId]:[];
                    this.projectOptions = this.allProjectList.filter(item=>item.value==this.projectId);
                    this.projectId&&this.changeProject([this.projectId]);
                    this.projectId = '';
                }
            },
            showBatchProject(){
                console.log('showBatchProject');
                const {vm} = batchProjectModal({
                    props: {

                    },
                    cbs:{
                        onSubmit:async (data)=>{
                            console.log('onSubmit-批量录入',data);
                            data.forEach(item=>{
                                // debugger;
                                if(!this.projectOptions.find(inner=>inner.value==item.project_id)){
                                    this.projectOptions.push({
                                        value:item.project_id,
                                        label:item.project_name,
                                    });
                                }
                                if(!this.allProjectList.find(inner=>item.project_id==inner.value)){
                                    this.allProjectList.push({
                                        value:item.project_id,
                                        label:item.project_name,
                                    })
                                }
                                if(!this.projectData.includes(item.project_id)){
                                    this.projectData.push(item.project_id);
                                }
                            });
                            await this.getProjectDetail();
                        },
                    },
                })
            },
            changeProject(val){
                console.log('changeProject',val);
                if(Array.isArray(val)&&val.length<=0){
                    this.fixedProjectError = false;
                }

                let checkedList = [];
                if(val.includes('all-option')){
                    checkedList = this.allProjectList.map(item=>item.value);
                    let oldVal = this.projectData;
                    let newVal = [...checkedList].filter(item=>!oldVal.includes(item));
                    console.log(777,oldVal,newVal);
                    this.projectData = oldVal.concat(newVal);
                }else if(val.includes('clear-option')){
                    checkedList = this.allProjectList.map(item=>item.value);
                    checkedList.forEach(item=>{
                        let index = this.projectData.findIndex(inner=>inner==item);
                        if(index!=-1){
                            this.projectData.splice(index,1);
                        }
                    })
                }else{
                    if(this.formItem.create_type=='1'){
                        this.formItem.project_list = [];
                    }
                    checkedList = val;
                    this.projectData = checkedList;
                }

                if(this.projectData.length>0){
                    this.getProjectDetail({current_array: val});
                }else{
                    this.formItem.project_list = [];
                    this.formItem.material_group = [];
                }
                this.empty_project = false;
                this.$refs.ruleForm.clearValidate('project_list');
                this.$refs.ruleForm.clearValidate('material_group');
            },
            removeProject(val){
                console.log('removeProject',val,this.formItem.project_list);
                let projectItem = this.formItem.project_list.find(item=>item.project_id==val);
                Promise.resolve().then(()=> {
                   this.$refs.projectInfoRef.resetData();
                })
                if(!projectItem) return ;

                /* 判断项目列表里，相同的规格有几个 */
                let sameList = this.formItem.project_list.filter(item=>item.app_type&&item.app_type==projectItem.app_type&&item.game_classify==projectItem.game_classify);
                if(sameList.length<=1){
                    let groupIndex = this.formItem.material_group.findIndex(item=>item.app_type==projectItem.app_type&&item.game_classify==projectItem.game_classify);
                    if(groupIndex!=-1){
                        this.formItem.material_group.splice(groupIndex,1);
                    }
                }

                let listIndex = this.formItem.project_list.findIndex(item=>item.project_id==val);
                if(listIndex!=-1){
                    this.formItem.project_list.splice(listIndex,1);
                } 
            },
            async getProjectDetail(oldGroupData={}){
                let list = [];
                if(this.formItem.create_type=='1'){
                    list = this.projectId?[this.projectId]:[];
                }else{
                    list = this.projectData||[];
                }
                if(list.length<=0) return '请选择项目';

                this.projectDetailLoading = true;
                const curIds = this.formItem.project_list.map(v=>v.project_id);
                const ids = list.filter(v=>!curIds.includes(v))
                await API.getProjectDetail({
                    project_ids:ids,
                }).then(res=>{
                    console.log('getProjectDetail',res);
                    this.projectDetailLoading = false;
                    let resData = res.data||[];
                    const originData = oldGroupData?.originData;
                    let oldData = cloneDeep(this.formItem.project_list);
                    const list = (resData && resData?.list || []).filter(item=>{
                        let oldItem = oldData.find(inner=>inner.project_id==item.project_id);
                        return !oldItem;
                    });
                    // 编辑 复制回显
                    if (originData) {
                        const data = list.find(item=> item.project_id == originData.project_id);
                        if (data) {
                            data.avg_daily_cost = originData.avg_daily_cost;
                            data.is_new = originData.is_new;
                            data.game_classify = originData.game_classify;
                            // 特殊处理   编辑时有些是无效数据   要取新的
                            data.package_type = originData.package_type === '0'? data.package_type : originData.package_type;
                            data.bloc_name = originData.bloc_name;
                            data.company_name = originData.company_name;
                            data.project_tag11 = originData.project_tag11 || data.project_tag11;
                            data.project_tag12 = originData.project_tag12 || data.project_tag12;
                            data.products = originData.products || [];
                            data.has_material = originData.has_material;
                        }
                    }
                    this.formItem.project_list = [ ...this.formItem.project_list, ...list ];
                    this.setMaterialGroupData();
                    // if(this.formItem.project_list.every(item=>item.type=='-1')){
                    //     this.getMaterialGroup();
                    // }
                    this.getMaterialGroup(oldGroupData);

                    // 切换项目后，重置fixedProjectError的状态
                    this.$nextTick(()=>{
                        this.$refs.projectInfoRef.resetData();
                        if(this.hasProblemProject){
                            this.fixedProjectError = false;
                        }
                    })
                    if(resData.error_list && resData.error_list.length>0) {
                        let _this = this;
                        const {vm} = noAuthModal({
                            props: {
                                list: resData.error_list
                            },
                            cbs:{
                                onClose: (data) => {
                                    vm.close()
                                    this.delSelectItem(resData.error_list)
                                },
                                toAccountPage(idList){
                                    let cid = new Date().getTime();
                                    let $router= _this.$router.resolve({
                                        name:'bind_media_account',
                                        query:{
                                              query_account:cid,
                                        },
                                    });
                                    let isHasPageAuth = ($router.href||'').includes('bind_media_account');
                                    if(isHasPageAuth){
                                        localStorage.setItem("wordOrderAccount_"+cid, JSON.stringify(uniq(idList)));
                                        window.open($router.href, '_blank');
                                    }else{
                                        let routeNoAuth = _this.$router.resolve({
                                            name: 'no-auth',
                                        });
                                        window.open(routeNoAuth.href, '_blank');
                                    }
                                }
                            },
                            on: {
                                close: ()=>{
                                    vm.close()
                                    this.delSelectItem(resData.error_list)
                                }
                            }
                        })
                    }


                },err=>{
                    console.log('getProjectDetail err',err, oldGroupData?.current_array);
                    if(this.formItem.create_type=='1'){
                        this.projectId = '';
                    }else if(this.formItem.create_type=='2'){
                        this.projectData = difference(this.projectData, oldGroupData?.current_array || []);
                    }
                    this.projectDetailLoading = false;
                    this.$message.error(err.info||'请求异常');
                })
            },
            delSelectItem(errList) {
                if(this.formItem.create_type=='1'){
                    this.projectId = ''
                }else{
                    // let result =
                    errList && errList.forEach(item=>{
                        let index = this.projectData.findIndex(inner=>inner==item.project_id);
                        if(index!=-1){
                            this.projectData.splice(index,1);
                        }

                    })
                }
                let ids = errList.map(item=>item.project_id);
                this.formItem.project_list = this.formItem.project_list.filter(item=>!ids.includes(item.project_id));
                this.$refs.projectInfoRef.resetData();
                this.getProjectDetail();
            },

            setMaterialGroupData(){
                let oldData = cloneDeep(this.formItem.material_group);
                let newList = [];
                this.formItem.project_list.forEach(item=>{
                    // 仅显示正常的项目
                    if(item.app_type=='1'||(item.app_type=='2'&&item.game_classify)){
                        let actionItem = null;
                        let newItem = null;
                        if(item.app_type=='1'){
                            // 应用
                            actionItem = oldData.find(inner=>inner.app_type==item.app_type);
                            newItem = newList.find(inner=>inner.app_type==item.app_type);
                        }else{
                            actionItem = oldData.find(inner=>inner.app_type==item.app_type&&inner.game_classify==item.game_classify);
                            newItem = newList.find(inner=>inner.app_type==item.app_type&&inner.game_classify==item.game_classify);
                        }


                        if(!newItem){
                            // 如果新列表里不存在，就push进去
                            if(actionItem){
                                // 旧的数据里有，push旧数据进去
                                newList.push({...actionItem});
                            }else{
                                // 旧的数据里没有，push空数据进去
                                newList.push({
                                    group_id:'',
                                    group_name:'',
                                    app_type:item.app_type,
                                    game_classify:item.app_type=='1'?'':item.game_classify,
                                    groupOptions:[],
                                })

                            }
                        }
                    }
                });
                this.formItem.material_group = newList;
            },
            remoteProjectMethod: debounce(function(query){
                this.remoteProjectMethodDebounce(query);
            }, 400),
            remoteProjectMethodDebounce(query){

                if (query.length >0) {
                    this.remoteProjectLoading = true;
                    API.getProjectOptions({
                        search:query,
                    }).then(res=>{
                        let resData = (res.data||{}).list||[];
                        this.projectOptions = resData.map(item=>{
                            if(!this.allProjectList.find(inner=>item.project_id==inner.value)){
                                this.allProjectList.push({
                                    value:item.project_id,
                                    label:item.project_name,
                                })
                            }
                            return {
                                value:item.project_id,
                                label:item.project_name,
                            }
                        });
                        this.remoteProjectLoading = false;
                    },err=>{
                        console.log('getOrgSelectorList err',err);
                        this.projectOptions = [];
                        this.remoteProjectLoading = false;
                        if (err?.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                    })

                } else {
                    this.projectOptions = [];
                }
            },
            showProjectInfo(){
                let projectList = this.formItem.project_list;
                console.log('projectList', projectList)
                if(projectList.length<=0) return this.$message.error('请先选择项目');
                projectInfoDrawer({
                    props: {
                        data:projectList,
                        isEdit:this.isEdit,
                        isCopy:this.isCopy,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：保存',data);
                            // this.getDataList();
                            data.forEach(item=>{
                                let actionItem = this.formItem.project_list.find(inner=>inner.project_id==item.project_id);
                                if(actionItem){
                                    actionItem.app_type=item.app_type;
                                    actionItem.game_classify=item.game_classify;
                                    actionItem.avg_daily_cost=item.avg_daily_cost;
                                    actionItem.need_cost=item.need_cost;
                                    actionItem.package_type=item.package_type;
                                    actionItem.products=item.products || [];
                                }
                            });
                            this.setMaterialGroupData();
                            this.getMaterialGroup();
                            // this.fixedProjectError = true;
                            this.$refs.ruleForm.clearValidate('project_list');
                            this.$refs.ruleForm.clearValidate('material_group');
                        },
                    },
                    // slots:{
                    //     title:(h)=>h('span',{ class: 'text-bold font14px' },'项目详情'),
                    // },
                });
            },
            updateProjectList(data) {
                 data.forEach(item=>{
                    let actionItem = this.formItem.project_list.find(inner=>inner.project_id==item.project_id);
                    if(actionItem){
                        actionItem.app_type=item.app_type;
                        actionItem.game_classify=item.game_classify;
                        actionItem.avg_daily_cost=item.avg_daily_cost;
                        actionItem.need_cost=item.need_cost;
                        actionItem.package_type=item.package_type;
                        actionItem.products=item.products || [];
                    }
                });
                this.setMaterialGroupData();
                this.getMaterialGroup();
                // this.fixedProjectError = true;
                this.$refs.ruleForm.clearValidate('project_list');
                this.$refs.ruleForm.clearValidate('material_group');
            },
            validateDetails(){
                this.formItem.detail.forEach((item,index)=>{
                    this.$refs['detail'+index+'plat_id'].validate();
                    this.$refs['detail'+index+'delivery_scene'].validate();
                    this.$refs['detail'+index+'delivery_type'].validate();
                    this.$refs['detail'+index+'size'].validate();
                    this.$refs['detail'+index+'material_format'].validate();
                    this.$refs['detail'+index+'material_size'].validate();
                    this.$refs['detail'+index+'material_num'].validate();
                    this.$refs['detail'+index+'label_ids'].validate();
                    this.$refs['detail'+index+'urgent_level'].validate();
                    this.$refs['detail'+index+'expected_end_time'].validate();
                    if(this.formItem.material_type=='2'){
                        this.$refs['detail'+index+'material_duration'].validate();
                    }
                })
            },
            submitData(){
                this.validateDetails();
                this.$refs.ruleForm.validate((valid,errors)=>{
                    if(valid){

                        let stopTags = [];
                        this.formItem.detail.forEach(task=>{
                            let delete_labels = task.delete_labels||[];
                            delete_labels.forEach(item=>{
                                if(!stopTags.find(inner=>inner.id==item.id)){
                                    stopTags.push({...item});
                                }
                            })
                        });

                        if(stopTags.length>0){
                            this.$message.error('标签：【'+stopTags.map(item=>item.name).join('、')+'】已被停用，请删除后继续');
                            return false;
                        }else{
                            this.checkCapacityThenSubmit();
                        }

                    }else{
                        let fieldMap={
                            create_type:'创建方式',
                            project_list:'项目名称',
                            material_type:'素材类型',
                            material_group:'制作部门',
                            order_name:'工单名称',
                            detail:'任务明细',
                            content:'内容要求',
                            avoid_content:'避免要素',
                            special_content:'特殊备注',
                            attachment:'附件上传',
                        };
                        let errList = [];
                        for (let field in errors){
                            errList.push(fieldMap[field]+'：'+errors[field][0].message);
                        }

                        this.errorFormList = errList;
                        this.submitLoading = false;
                        this.popoverVisible = true;

                        console.log('error submit!!',this.errorFormList);
                        return false;
                    }
                });
            },
            async checkCapacityThenSubmit() {
                // 产能提醒（2026-08-03 恢复·纯提醒不阻断）：黄/红/非工作日弹框告知，用户可点「仍要提交」照常下单。
                // 灰度由**后端**控（开关 create_capacity_notice）：不在名单的用户拿到的恒是绿信号 → 这里自然不弹。
                // ⚠️ 超产能审批（type=3）不随之恢复：不再收集原因、不再透传，over_capacity_reason 恒空。
                try {
                    const dates = (this.formItem.detail || []).map(d => d.expected_end_time).filter(Boolean)
                    // 本单总需求数 = Σ明细 material_num（判超产能：本单需求 + 期望日现有 vs 当日cap）
                    const demand = (this.formItem.detail || []).reduce((s, d) => s + (Number(d.material_num) || 0), 0)
                    // 已选制作部门（CSV·与提交时 tb_td_work_order.group_id 同源同口径：material_group[].group_id）。
                    // 同一素材类型配了多个大类时，服务端靠它定位大类；不传会退回「取最小大类 id」，可能把
                    // 超产能判定钉在无产能的大类上 → 提醒恒不触发（BUG-002-BR）。
                    const groupIds = (this.formItem.material_group || [])
                        .map(i => i.group_id).filter(Boolean).join(',')
                    const res = await getCreateSchedulePreview({
                        material_type: this.formItem.material_type,
                        expect_dates: dates,
                        demand: demand,
                        group_ids: groupIds
                    })
                    const data = res && res.data
                    const sig = data && data.worst_signal
                    // 非工作日：那天无产能·不算超产能·但也弹框提示（引擎将排到工作日）
                    const nonWorkday = !!(data && data.judge_is_workday === false && data.judge_day)
                    if (sig === 'yellow' || sig === 'red' || nonWorkday) {
                        this.capacityPreview = {
                            visible: true,
                            waterList: data.water || [],
                            recommendDate: data.recommend_date || '',
                            worstSignal: sig,
                            categoryGroupName: data.category_group_name || '',
                            judgeDay: data.judge_day || '',
                            judgeIsWorkday: data.judge_is_workday !== false,
                            demand: data.demand || 0,
                            judgeRatio: data.judge_ratio || 0
                        }
                        return // 等用户在弹框点「仍要提交」
                    }
                } catch (e) {
                    // 预览失败不阻断下单（纯提醒）
                }
                this.doSubmitData()
            },
            onCapacityConfirm() {
                // 纯提醒·不收原因（超产能审批已下线）→ over_capacity_reason 恒空
                this.overCapacityReason = ''
                this.capacityPreview.visible = false
                this.doSubmitData()
            },
            onCapacityCancel() {
                this.capacityPreview.visible = false
            },
            doSubmitData(){
                this.errorFormList = [];
                if(this.submitLoading) return;
                this.submitLoading = true;
                let detailData = cloneDeep(this.formItem.detail);

                API.checkProjectMaterial({
                    project_id:this.formItem.project_list.map(item=>item.project_id),
                    material_w_h:this.formItem.detail.map(item=>{
                        return item.width+'*'+item.height;
                    }),
                    material_type: this.tempData.material_type
                }).then((preRes)=>{
                    // let preResData = preRes.data||[];
                    let list = preRes.data||[];
                    // Object.keys(preResData).forEach(item=>{
                    //     list.push({
                    //         id:item,
                    //         name:preResData[item],
                    //     })
                    // });

                    if(list.length>0){
                        //返回了项目id和项目名称，表示需要弹窗提示
                        this.submitLoading = false;
                        this.submitSign = utils.randomString();
                        submitTipModal({
                            props: {
                                list:list,
                            },
                            cbs:{
                                goOnSubmit:(data)=>{
                                    console.log('goOnSubmit：保存',data);
                                    API.saveBuriedPoint({
                                        steps:'2',
                                        id:this.buriedPointId,
                                        type:this.isEdit?'2':'1',      // 1-创建 2-修改
                                        project_id:list.map(item=>item.project_id),
                                        click_type:'2',
                                        order_id:this.isEdit?this.id:'',
                                    });

                                    this.submitLoading = true;
                                    // 直接提交
                                    let reqData = {
                                        order_name:this.formItem.order_name,
                                        create_type:this.formItem.create_type,
                                        project_list:this.$refs.projectInfoRef.dataList,
                                        material_type:this.formItem.material_type,
                                        material_group:this.formItem.material_group,
                                        detail:detailData.map(item=>{
                                            item.delivery_type = item.delivery_type[0]||'';
                                            return item;
                                        }),
                                        content:this.formItem.content,
                                        avoid_content:this.formItem.avoid_content,
                                        special_content:this.formItem.special_content,
                                        attachment:this.formItem.attachment,
                                        create_id:this.buriedPointId,
                                        over_capacity_reason:this.overCapacityReason||'', // 超产能强制下单原因(仅red档非空)
                                    };

                                    let apiType = 'saveOrder';
                                    if(this.isEdit){
                                        apiType = 'updateOrder';
                                        reqData.id = this.id;
                                    }


                                    API[apiType](reqData,{
                                        timeout:120*1000,
                                    }).then(res=>{
                                        console.log('saveOrder',res);
                                        this.submitLoading = false;
                                        this.$message.success(res.info||'操作成功');
                                        // this.$emit('changePage', 'MaterialPage', {}, apiType === 'saveOrder' ? 'add' : 'edit');
                                        let cur_active = ''
                                        if(apiType === 'saveOrder') {
                                            cur_active = '1';
                                        }else{
                                            cur_active = this.query.tagsActive ? this.query.tagsActive.toString() : '1'
                                        }
                                        this.$router.push({
                                            name:'work_order_material',
                                            query: {
                                                topage: 'MaterialPage',
                                                reload: apiType === 'saveOrder' ? 'add' : 'edit',
                                                tagsActive: cur_active
                                            },
                                            params:{
                                                menuReload: 1
                                            }
                                        });
                                    },err=>{
                                        console.log('saveOrder err',err);
                                        this.submitLoading = false;
                                        if (err?.code == '403') {
                                            this.$confirm(err.info||'请求异常', '提示', {
                                                confirmButtonText: '刷新',
                                                type: 'warning',
                                                showClose: false,
                                                closeOnClickModal: false,
                                                closeOnPressEscape: false
                                            }).then(() => {
                                                window.location.reload()
                                            }).catch(() => {
                                            });
                                            return
                                        }

                                        let msgData = err.data||[];
                                        if(Array.isArray(msgData)&&msgData.length>0){
                                            this.errorFormList = msgData;
                                            this.popoverVisible = true;
                                        }else{
                                            this.$message.error(err.info||'操作失败');
                                        }
                                    })
                                },
                                onClose:()=>{
                                    console.log('onClose',666);
                                    API.saveBuriedPoint({
                                        steps:'2',
                                        id:this.buriedPointId,
                                        type:this.isEdit?'2':'1',       // 1-去看看 2-继续提交
                                        project_id:list.map(item=>item.project_id),
                                        click_type:'',
                                        order_id:this.isEdit?this.id:'',
                                    });
                                },
                                toProjectPage:()=>{
                                    console.log('toProjectPage',777);
                                    API.saveBuriedPoint({
                                        steps:'2',
                                        id:this.buriedPointId,
                                        type:this.isEdit?'2':'1',      // 1-创建 2-修改
                                        project_id:list.map(item=>item.project_id),
                                        click_type:'1',
                                        order_id:this.isEdit?this.id:'',
                                    });

                                    let sizeList = [];
                                    list.forEach(item=>{
                                        let innerList = Object.keys(item.list||{});
                                        innerList.forEach(inner=>{
                                            if(!sizeList.includes(inner)){
                                                sizeList.push(inner);
                                            }
                                        })
                                    });
                                    let $router= this.$router.resolve({
                                        name:'material',
                                        query:{
                                            material_type:this.formItem.material_type,
                                            project:encodeURIComponent(JSON.stringify(list.map(item=>{
                                                return {
                                                    label:item.project_name,
                                                    value:item.project_id,
                                                }
                                            }))),
                                            material_w_h_DataList:encodeURIComponent(JSON.stringify(sizeList.map(item=>{
                                                return {
                                                    name:item,
                                                    id:item,
                                                }
                                            }))),
                                            is_used:'2',    // 使用状态  1使用 2未使用
                                        },
                                    });
                                    window.open($router.href, '_blank');
                                },
                            },
                        });



                    }else{
                        // 直接提交

                        let reqData = {
                            order_name:this.formItem.order_name,
                            create_type:this.formItem.create_type,
                            project_list:this.$refs.projectInfoRef.dataList,
                            material_type:this.formItem.material_type,
                            material_group:this.formItem.material_group,
                            detail:detailData.map(item=>{
                                item.delivery_type = item.delivery_type[0]||'';
                                return item;
                            }),
                            content:this.formItem.content,
                            avoid_content:this.formItem.avoid_content,
                            special_content:this.formItem.special_content,
                            attachment:this.formItem.attachment,
                            create_id:this.buriedPointId,
                            over_capacity_reason:this.overCapacityReason||'', // 超产能强制下单原因(仅red档非空)
                        };

                        let apiType = 'saveOrder';
                        if(this.isEdit){
                            apiType = 'updateOrder';
                            reqData.id = this.id;
                        }


                        this.submitLoading = true;
                        API[apiType](reqData,{
                            timeout:120*1000,
                        }).then(res=>{
                            console.log('saveOrder',res);
                            this.pushMatomo(this.titleText + '工单(提交)')
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            let cur_active = ''
                            if(apiType === 'saveOrder') {
                                cur_active = '1';
                            }else{
                                cur_active = this.query.tagsActive ? this.query.tagsActive.toString() : '1'
                            }
                            this.$router.push({
                                name:'work_order_material',
                                query: {
                                    topage: 'MaterialPage',
                                    reload: apiType === 'saveOrder' ? 'add' : 'edit',
                                    tagsActive: cur_active
                                },
                                params:{
                                    menuReload: 1
                                }
                            });
                        },err=>{
                            console.log('saveOrder err',err);
                            this.submitLoading = false;
                            if (err?.code == '403') {
                                this.$confirm(err.info||'请求异常', '提示', {
                                    confirmButtonText: '刷新',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                });
                                return
                            }

                            let msgData = err.data||[];
                            if(Array.isArray(msgData)&&msgData.length>0){
                                this.errorFormList = msgData;
                                this.popoverVisible = true;
                            }else{
                                this.$message.error(err.info||'操作失败');
                            }
                        })
                    }
                },err=>{
                    this.submitLoading = false;
                    this.$message.error(err.info||'操作失败');
                });
            },
            setDefaultRow(){
                this.formItem.detail = [{...this.baseConfig}];
            },
            getOrderInfo(){
                this.pageLoading = true;
                return new Promise((resolve,reject)=>{
                    API.getOrderInfo({
                        order_id:this.id,
                    }).then(async res=>{
                        this.pageLoading = false;
                        console.log('getOrderInfo',res);
                        let resData = res.data||{};
                        /* order_status：3-被驳回 */
                        if(resData.rejected_reason&&resData.order_status=='3'){
                            this.rejectedReason = resData.rejected_reason;
                        }
                        this.formItem.create_type = '1';    // 修改和编辑都是单独项目
                        this.projectId = resData.project_id;
                        this.projectData = [];
                        this.projectOptions = [{
                            value:resData.project_id,
                            label:resData.project_name,
                        }];
                        this.allProjectList = [{
                            value:resData.project_id,
                            label:resData.project_name,
                        }];
                        this.formItem.material_type = resData.material_type;
                        this.tempData.material_type = resData.material_type;
                        await this.getMaterialFormat1();

                        this.formItem.material_group = [{
                            group_id:this.isEdit||this.isCopy?resData.group_id:'',
                            group_name:this.isEdit||this.isCopy?resData.group_name:'',
                            app_type:resData.app_type,
                            game_classify:resData.game_classify,
                            groupOptions:[{
                                id:resData.group_id,
                                name:resData.group_name,
                            }],
                        }];
                        if(this.isCopy||this.isEdit){
                            this.getProjectDetail({
                                id:resData.group_id,
                                name:resData.group_name,
                                originData: resData
                            });
                        }else{
                            this.formItem.project_list = [{
                                // app_type:resData.app_type,
                                // avg_daily_cost:resData.avg_daily_cost||undefined,
                                // game_classify:resData.game_classify,
                                // need_cost:false,
                                project_id:resData.project_id,
                                project_name:resData.project_name,
                                // type:'-1',
                            }];
                        }
                        this.getMaterialGroup({
                            id:resData.group_id,
                            name:resData.group_name,
                        });
                        this.getLabelConfig();

                        // 工单名称-通配符
                        let orderNameWildCard = resData.order_name_wild_card;
                        if(orderNameWildCard){
                            this.formItem.order_name = orderNameWildCard;
                        }else{
                            this.formItem.order_name = resData.order_name+(this.isCopy?'_复制':'');
                        }

                        this.formItem.content = resData.content;
                        this.formItem.avoid_content = resData.avoid_content;
                        this.formItem.special_content = resData.special_content;
                        this.formItem.detail = resData.detail.map((item,index)=>{
                            item.label_ids = (item.label_list||[]).map(item=>item.id);
                            item.deliverySceneList = item.deliverySceneList.map(inner=>{
                                return {
                                    id:inner.delivery_scene_id,
                                    name:inner.delivery_scene,
                                }
                            });
                            item.deliveryTypeList = [];
                            let id = item.width+'*'+item.height+'/'+item.material_format.join('/')+'/'+item.material_size+item.material_size_unit;
                            if(resData.material_type=='2'){
                                item.material_duration = +item.material_duration;
                                id = id +'/'+item.material_duration+'s';
                            }

                            item.delivery_type = [item.delivery_type,id];
                            item.formatList = [];
                            item.width = +item.width;
                            item.height = +item.height;
                            item.material_size = +item.material_size;
                            return item;
                        });
                        this.formItem.detail.forEach((item,index)=>{
                            this.changeDeliveryScene(item.delivery_scene,index,true);
                        });
                        this.formItem.attachment = resData.attachment||[];
                        this.empty_project = resData.empty_project||false;
                    },err=>{
                        this.pageLoading = false;
                        console.log('getOrderInfo err',err);
                    }).finally(()=>{
                        resolve()
                    })
                })

            },

            addRow(row,index){
                console.log('addRow',row,index);
                this.formItem.detail.splice(index+1, 0, {...this.baseConfig});
            },
            copyRow(index){
                console.log('copyRow',index);
                let data = {...this.formItem.detail[index]};
                data.id='';
                this.formItem.detail.push(data);
            },
            deleteRow(index){
                console.log('deleteRow',index);
                if(this.formItem.detail.length<=1){
                    return this.$message.error('不能再删了……');
                }
                this.formItem.detail.splice(index,1);
            },
            isNotNeedConfirm(row){
                if(this.formItem.detail.length==1) return true;
                return !(row.plat_id||row.delivery_scene||row.delivery_type.length>0||row.width||row.height||row.material_format.length>0||row.material_size||row.material_duration||row.material_num||row.urgent_level||row.expected_end_time||(row.label_ids||[]).length>0);
            },
            changePlat(val,index){
                console.log('changePlat',val,index);
                this.formItem.detail[index].delivery_scene = '';
                this.formItem.detail[index].delivery_type = [];
                this.formItem.detail[index].deliverySceneList = [];
                this.formItem.detail[index].deliveryTypeList = [];
                API.getDeliveryList({
                    plat_id:val,
                    search_type:'delivery_scene',
                }).then(res=>{
                    console.log('getDeliveryList',res);
                    this.formItem.detail[index].deliverySceneList = (res.data||[]).map(item=>{
                        return {
                            id:item.delivery_scene_id,
                            name:item.delivery_scene,
                        }
                    });
                },err=>{
                    console.log('getDeliverySceneOptions err',err);
                    this.formItem.detail[index].deliverySceneList = [];
                });
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeTempMaterialType(val){
                if(this.formItem.detail.some(item=>item.plat_id)){
                    this.$confirm('素材类型切换时仅会保留需求数量、紧急程度、期望完成日期，是否继续？', '提示', {
                        confirmButtonText: '继续',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.formItem.material_type = val;
                        this.changeMaterialType(val);
                    }).catch(() => {
                        this.tempData.material_type = this.formItem.material_type;
                    });
                }else{
                    this.formItem.material_type = val;
                    this.changeMaterialType(val);
                }
            },
            async changeMaterialType(val){
                console.log('changeMaterialType',val);
                await this.getMaterialFormat1();

                this.formItem.detail.forEach(item=>{
                    item.material_duration = undefined;
                    item.material_format = [];
                    item.label_ids = [];
                });


                this.formItem.material_group.forEach(item=>{
                   item.group_id = '';
                   item.group_name = '';
                });

                this.getMaterialGroup();
                this.getLabelConfig();

                /* 需要清除Cascader组件内的各种值，要不然会报错 */
                this.formItem.detail.forEach((row,index)=>{
                    let $refDeliveryTypeCascader = this.$refs['deliveryTypeCascader'+index];
                    if($refDeliveryTypeCascader){
                        let $panel1 = $refDeliveryTypeCascader.$refs.panel;
                        if($panel1){
                            $panel1.checkedValue = [];
                            $panel1.clearCheckedNodes();
                            $panel1.activePath = [];
                            $panel1.syncActivePath();
                        }
                    }

                    let $refLabelCascader = this.$refs['labelCascader'+index];
                    if($refLabelCascader){
                        let $panel2 = $refLabelCascader.$refs.panel;
                        if($panel2){
                            $panel2.checkedValue = [];
                            $panel2.clearCheckedNodes();
                            $panel2.activePath = [];
                            $panel2.syncActivePath();
                        }
                    }
                });
                this.labelList = [];
                this.formItem.detail.forEach((row,index)=>{
                    row.formatList = this.formatList;
                    row.label_ids = [];
                    row.delivery_scene = '';
                    row.delivery_type = [];
                    row.width = undefined;
                    row.height = undefined;
                    row.material_format = [];
                    row.material_size = '';
                    row.material_size_unit = val==='1'?'KB':'MB';
                    row.material_duration = undefined;
                    row.deliverySceneList = [];
                    row.deliveryTypeList = [];
                    row.plat_id = '';

                });

            },
            getMaterialGroup(oldData={}){
                console.log(this.formItem.material_group, '-----');
                this.formItem.material_group.forEach(item=>{
                    let orItem = cloneDeep(item);
                    API.getMaterialGroup({
                        app_type:item.app_type,
                        game_classify:item.game_classify,
                        material_type:this.formItem.material_type,
                    }).then(res=>{
                        console.log('getMaterialGroup',item,res);
                        let actionGroup = this.formItem.material_group.find(inner=>inner.app_type==item.app_type&&inner.game_classify==item.game_classify);
                        if(actionGroup){
                            let resData = res.data||[];
                            this.$set(actionGroup,'groupOptions',resData);
                            if(resData.length>0){
                                if(this.isEdit){
                                    // getOrderInfo里会设置值
                                    if(oldData.id||orItem.group_id){
                                        if(resData.find(inner=>inner.id==oldData.id||inner.id==orItem.group_id)){
                                            actionGroup.group_id= oldData.id||orItem.group_id||'';
                                            actionGroup.group_name= oldData.name||orItem.group_name||'';
                                        }else{
                                            actionGroup.group_id= '';
                                            actionGroup.group_name= '';
                                        }
                                    }else{
                                        actionGroup.group_id= '';
                                        actionGroup.group_name= '';
                                    }
                                }else{
                                    if(!actionGroup.group_id){
                                        actionGroup.group_id='';
                                        actionGroup.group_name= '';
                                    }
                                }
                            }
                        }
                    },err=>{
                        console.log('getMaterialGroup err',err);
                        this.$message.error(err.info||'请求异常');
                    })
                })
            },
            changeMaterialGroup(val,item){
                console.log('changeMaterialGroup',val,item);
                let actionGroup = item.groupOptions.find(inner=>inner.id==val)||{};
                item.group_name = actionGroup.name||'';
            },
            changeOrderName(val){
                console.log('changeOrderName',val);
                this.$refs.ruleForm.validateField('order_name');
            },
            getLabelConfig(){
                let apiType = this.formItem.material_type=='1'?'getImageLabelConfigList':'getVideoLabelConfigList';
                API[apiType]({source: 0}).then(res=>{
                    console.log('getLabelConfigList',res);
                    let resData = res.data||[];
                    this.labelList = resData.map(item=>{
                        item.level = '1';
                        item.deleteLoading = false;
                        if(Array.isArray(item.children)&&item.children.length>0){
                            item.children = item.children.map(inner=>{
                                inner.deleteLoading = false;
                                inner.level = '2';
                                return inner;
                            })
                        }
                        return item;
                    });
                },err=>{
                    console.log('getLabelConfigList err',err);
                    if (err?.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }

                })
            },
            changeDeliveryScene(val,index,isSet){
                console.log('changeDeliveryScene',val,index);
                let actionDetail = this.formItem.detail[index];
                if(!isSet){
                    actionDetail.delivery_type = [];
                    actionDetail.deliveryTypeList = [];
                }

                API.getMaterialDetail({
                    material_type:this.formItem.material_type,
                    plat_id:actionDetail.plat_id,
                    delivery_scene:actionDetail.delivery_scene,
                }).then(res=>{
                    console.log('getMaterialDetail',res);

                    actionDetail.deliveryTypeList = (res.data||[]).map(item=>{
                        let data = {
                            id:item.delivery_type_id,
                            name:item.delivery_type,
                        };
                        data.children = item.config_list.map(inner=>{
                            if(inner.width&&inner.height){
                                inner.id = inner.width+'*'+inner.height+'/'+inner.material_format.join('/')+'/'+inner.material_size+inner.material_size_unit+(this.formItem.material_type=='2'?'/'+inner.material_duration+'s':'');
                                inner.name = inner.id;
                            }else{
                                inner.id = item.delivery_type_id+'custom';
                                inner.name = '自定义尺寸';
                            }

                            inner.pid = item.delivery_type_id;
                            return inner;
                        });
                        return data;
                    });

                    if(isSet){
                        let oldVal = actionDetail.delivery_type||[];
                        let optionItem = actionDetail.deliveryTypeList.find(item=>item.id==oldVal[0])||{};
                        let children = optionItem.children||[];
                        let checkItem = children.find(inner=>(inner.width+'*'+inner.height+'/'+inner.material_format.join('/')+'/'+inner.material_size+inner.material_size_unit+(this.formItem.material_type=='2'?'/'+inner.material_duration+'s':''))==oldVal[1]);
                        if(!checkItem){
                            this.$set(actionDetail,'delivery_type',[oldVal[0],optionItem.id+'custom']);
                            this.$set(actionDetail,'formatList',this.formatList);
                        }else{
                            let materialFormat = checkItem.material_format||[];
                            this.$set(actionDetail,'formatList',materialFormat.length>0?materialFormat:this.formatList);
                        }
                    }
                },err=>{
                    console.log('getMaterialDetail err',err);
                    actionDetail.deliveryTypeList = [];
                })
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeDeliveryType(val,index){
                // delivery_type
                this.formItem.detail[index].delivery_type = val;

                if(val.length<=1){

                }else if(val[1].includes('custom')){
                    // this.formItem.detail[index].width = undefined;
                    // this.formItem.detail[index].height = undefined;
                    // this.formItem.detail[index].material_format = [];
                    // this.formItem.detail[index].material_size = '';
                    this.formItem.detail[index].formatList = [...this.formatList];
                }else{
                    let deliveryTypeItem = this.formItem.detail[index].deliveryTypeList.find(item=>item.id==val[0]);
                    if(deliveryTypeItem){
                        let childItem = (deliveryTypeItem.children||[]).find(item=>item.id==val[1]);
                        if(childItem){
                            this.formItem.detail[index].width = +childItem.width;
                            this.formItem.detail[index].height = +childItem.height;
                            this.formItem.detail[index].material_format = childItem.material_format||[];
                            this.formItem.detail[index].formatList = (childItem.material_format||[]).length>0?childItem.material_format:[...this.formatList];
                            this.formItem.detail[index].material_size = +childItem.material_size;
                            if(childItem.material_size_unit){
                                this.formItem.detail[index].material_size_unit = childItem.material_size_unit;
                            }
                            if(childItem.material_duration){
                                this.formItem.detail[index].material_duration = +childItem.material_duration;
                            }
                        }
                    }
                }

                // this.validateDetails();
                // this.$refs.ruleForm.clearValidate('detail');
                if(!val[1].includes('custom')){
                    this.validateDetailWidthHeightFormat(index);
                }
            },
            validateDetailWidthHeightFormat(index){
                this.$refs['detail'+index+'delivery_type'].validate();
                this.$refs['detail'+index+'size'].validate();
                this.$refs['detail'+index+'material_format'].validate();
                this.$refs['detail'+index+'material_size'].validate();
                if(this.formItem.material_type=='2'){
                    this.$refs['detail'+index+'material_duration'].validate();
                }
            },
            changeWidth(val,index){
                console.log('changeWidth',val,index);
                this.formItem.detail[index].width = val;
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeHeight(val,index){
                console.log('changeHeight',val,index);
                this.formItem.detail[index].height = val;
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeSize(val,index){
                console.log('changeSize',val,index);
                let value = isNaN(val)?null:+val;
                this.formItem.detail[index].material_size = value;
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeFormat(val,index){
                console.log('changeFormat',val,index);
                if(val.includes('all-option')){
                    let list = this.formItem.detail[index].formatList;
                    this.formItem.detail[index].material_format = list.map(item=>item);
                }else if(val.includes('clear-option')){
                    this.formItem.detail[index].material_format = [];
                }else{
                    this.formItem.detail[index].material_format = val;
                }
                this.$refs.ruleForm.clearValidate('detail');
            },
            getOptionsAllChecked(row,index,type){
                let list = this.formItem.detail[index].formatList;
                return row[type].length>0&&row[type].length == list.length;
            },
            changeUnit(val,index){
                console.log('changeUnit',val,index);
                this.formItem.detail[index].material_size_unit = val;
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeLabel(val,index){
                console.log('changeLabel',val,index);
                this.formItem.detail[index].label_ids = val;
                // this.$refs.ruleForm.clearValidate('detail');
            },
            removeDeleteTag(tag,index){
                console.log('changeLabel',tag,index);
                let tagIndex = (this.formItem.detail[index].delete_labels||[]).findIndex(item=>item.id==tag.key);
                if(tagIndex!='-1'){
                    this.formItem.detail[index].delete_labels.splice(index,1);
                }
            },
            changeMaterialNum(){
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeUrgentLevel(){
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeExpectedEndTime(){
                // this.$refs.ruleForm.clearValidate('detail');
            },
            changeMaterialDuration(){
                // this.$refs.ruleForm.clearValidate('detail');
            },

            // 上传loading
            handleProgress(val) {
                // console.log('handleProgress',val);
                this.uploadLoading = true;
            },
            async handleUpload(file){
                console.log('handleUpload',file);
                return new Promise(async (resolve,reject) => {
                    let fileSize = file.size;
                    let maxSize = 200*1024*1024;    // 200M
                    if(fileSize>maxSize){
                        this.$message.error(file.name+' 上传失败：文件大小不可超过200M');
                        reject();
                    }else if(file.name.length>100){
                        this.$message.error(file.name+' 上传失败：文件名称不能超过100个字符');
                        reject();
                    }else{
                        let md5 = await this.getFileMd5(file);
                        if(this.formItem.attachment.find(item=>item.md5==md5)){
                            this.$message.error(file.name+' 上传失败：文件不可以重复上传');
                            reject();
                        }else{
                            file.md5 = md5;
                            resolve();
                        }
                    }
                });
            },
            beforeRemove(file){
                console.log('beforeRemove',file);
                let fileData = file.response?file.response:file;
                let index = this.formItem.attachment.findIndex(item=>item.attachment_path==fileData.attachment_path);
                if(index!=-1){
                    this.formItem.attachment.splice(index,1);
                }
            },
            downloadFile(file){
                console.log('downloadFile',file);

                let url = file.attachment_path||'';
                url = url.includes('http')?url:('https://'+url);

                let link = document.createElement('a');
                link.style.display = 'none';
                document.body.appendChild(link);
                link.target='_blank';
                link.href = url;
                link.download = file.attachment_name;
                link.click();
                document.body.removeChild(link);
            },
            getFileMd5(file){
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = (e) => {
                        const content = e.target.result;
                        let fileMd5 = md5(content);
                        resolve(fileMd5);
                    };
                });
            },
            fileRequest(data){
                console.log('fileRequest',data,data.file,data.file.md5);
                let _this = this;
                COS.putObject(data.file, {
                    onProgress: data.onProgress,
                    onTaskReady: (taskId)=> {
                        _this.uploadTaskList.push(taskId);
                    }
                }).then(file=>{
                    if(file){
                        let fileUrl = file.Location;

                        if(_this.formItem.attachment.find(item=>item.md5==data.file.md5)){
                            _this.$message.error('文件重复，文件名：'+data.file.name);
                            data.onSuccess({});
                        }else{
                            _this.formItem.attachment.push({
                                attachment_name:data.file.name,
                                attachment_path:fileUrl,
                                md5:data.file.md5,
                            });

                            data.onSuccess({
                                attachment_name:data.file.name,
                                attachment_path:fileUrl,
                            });
                        }
                    }else{
                        data.onError(err,data.file);
                    }
                }).catch((err)=>{
                    console.log('fileRequest err',err);
                    this.$message.error(err.message ||'请求异常');
                });


            },
            handleSuccess(res){
                console.log('handleUpload',res);
                this.uploadLoading = false;
            },
            handleError(error, file, fileList){
                console.log('handleError',error, file,fileList);
                this.$message.error('文件上传失败：',file.name);
                this.uploadLoading = false;
            },
            stopUploading(){
                this.uploadTaskList.forEach(item=>{
                    COS.cancelTask(item);
                });
                this.uploadTaskList = [];
                this.uploadLoading = false;
            },
            checkDetailError(detailList){
                let errText = '';
                for (let i = 0; i < detailList.length; i++) {
                    let item = detailList[i];
                    if(!item.plat_id){
                        errText = '第'+(i+1)+'行：请选择投放媒体';
                        break;
                    }else if(!item.delivery_scene){
                        errText = '第'+(i+1)+'行：请选择投放场景';
                        break;
                    }else if(item.delivery_type.length<=0){
                        errText = '第'+(i+1)+'行：请选择投放版位';
                        break;
                    }else if(!item.width||!item.height){
                        errText = '第'+(i+1)+'行：请完整填写素材尺寸';
                        break;
                    }else if(item.width<=0||item.height<=0){
                        errText = '第'+(i+1)+'行：素材尺寸需大于0';
                    }else if(item.width>9999||item.height>9999){
                        errText = '第'+(i+1)+'行：素材尺寸最多支持4位数';
                        break;
                    }else if(item.width%1>0||item.height%1>0){
                        errText = '第'+(i+1)+'行：素材尺寸不支持小数';
                        break;
                    }else if(item.material_format.length<=0){
                        errText = '第'+(i+1)+'行：素材格式不能为空';
                        break;
                    }else if(!item.material_size){
                        errText = '第'+(i+1)+'行：素材大小不能为空';
                        break;
                    }else if(isNaN(item.material_size)){
                        errText = '第'+(i+1)+'行：素材大小必须为正整数';
                        break;
                    }else if(item.material_size<=0){
                        errText = '第'+(i+1)+'行：素材大小需大于0';
                        break;
                    }else if(item.material_size>9999){
                        errText = '第'+(i+1)+'行：素材大小最大支持4位正整数';
                        break;
                    }else if(!item.material_num){
                        errText = '第'+(i+1)+'行：请填写需求数量';
                        break;
                    }else if(item.material_num<=0||+item.material_num%1>0){
                        errText = '第'+(i+1)+'行：需求数量仅支持正整数';
                        break;
                    }else if((item.delete_labels||[]).length>0){
                        errText = '第'+(i+1)+'行：标签被停用，请删除后继续：'+item.delete_labels.map(item=>item.name).join('、');
                        break;
                    }else if(item.label_ids.length<=0){
                        errText = '第'+(i+1)+'行：请选择素材标签';
                        break;
                    }else if(!item.urgent_level){
                        errText = '第'+(i+1)+'行：请选择任务紧急程度';
                        break;
                    }else if(!item.expected_end_time){
                        errText = '第'+(i+1)+'行：请选择期望完成日期';
                        break;
                    }else if(dayjs().isAfter(dayjs(item.expected_end_time),'day')){
                        errText = '第'+(i+1)+'行：期望完成时间不可早于今天';
                        break;
                    }else if(this.formItem.material_type=='2'){
                        if(!item.material_duration){
                            errText = '第'+(i+1)+'行：视频时长不能为空';
                            break;
                        }else if(item.material_duration<=0||+item.material_duration%1>0){
                            errText = '第'+(i+1)+'行：视频时长仅支持正整数';
                            break;
                        }else if(item.material_duration>999){
                            errText = '第'+(i+1)+'行：视频时长不能大于3位数';
                            break;
                        }
                    }
                }
                return errText;
            },
            toAppManagementPage(){
                let routeData = this.$router.resolve({
                    name: 'customer_app_management_new',
                });
                let route404 = this.$router.resolve({
                    name: '404',
                });
                // console.log('toAppManagementPage',routeData,route404);
                window.open((routeData.href||'').includes('customer_app_management_v2')?routeData.href:route404.href, '_blank');
            },
        },
        beforeDestroy(){
            this.$store.commit('workOrder/UPDATE_CREATE_PAGE_STATUS', false);
            window.removeEventListener("resize", this.getFixWidth);
            window.onbeforeunload = null;
        },
    }
</script>

<style lang="scss" scoped>
    .create_page_wrap{
        min-height: calc(100vh - 50px);
        position: relative;
        padding: 10px;
        &:before{
            content: '';
            position: fixed;
            display: block;
            left: 0;
            right: 0;
            width: 100%;
            height: 10px;
            background-color: #f1f4f9;
            z-index: 2;
            top: 50px;
        }
        &::v-deep .el-collapse-item__header{
            background-color: #d7eaff;
            border-radius: 6px;
            padding-left: 10px;
            font-weight: bold;
        }
    }
    .create_page_header{
        background-color: #fff;
        padding: 4px 8px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        position: fixed;
        top: 60px;
        z-index: 3;
        box-shadow: 0px 1px 2px #d9d9d9;
        .text {
            display:inline-block;
            line-height: 32px;
        }
    }
    .create_page_content {
        margin-top: 52px;
        background-color: #fff;
        height:  calc(100vh - 130px);
        display: flex;
    }
    .project_list {
        width: 450px;
        flex-shrink: 0;
         height: 100%;
        overflow: auto;
    }
    .product-notice.el-alert--info.is-light {
        margin-bottom: 16px;
        background-color: #e8f3ff;
        border: 1px solid #bdd7f0;
        color: #20527d;
    }
    .create_page_body{
        padding-right: 20px;
        position: relative;
        overflow: hidden;
        flex: 1;
        height: 100%;
        overflow: auto;
        &::after{
            content: '';
            position: absolute;
            display: block;
            right: 0;
            top: 20px;
            bottom: 20px;
            width: 4px;
            background-color: #f0f0f0;
        }
    }

    /* 修正input prepend显示的小竖杠 */
    ::v-deep .el-input-group__prepend{
        padding: 0 10px;
        &::after{
            display: none;
        }
    }

    /* 上传样式 */
    .upload-box{
        width: 400px;
        ::v-deep .el-upload {
            width: 100%;
            .el-upload-dragger{
                width: 100%;
                height: 150px;
                padding-top: 20px;
                .el-icon-upload{
                    font-size: 40px;
                    margin: 0 auto;
                    line-height: 40px;
                    color: #409EFF;
                }
                .el-upload__text{
                    font-size: 12px;
                }
            }
        }
        .upload-loading-wrap{
            position: absolute;
            z-index: 2;
            right: 20px;
            top: 10px;
            cursor: pointer;
            color: #409EFF;
            .el-icon-loading{
                font-size: 30px;
            }
        }
    }



    .text-color-form{
        color: #606266;
    }
    .material-group-label{
        width: 120px;
    }

    .rejected_reason{
        background-color: #fff;
        margin: -20px;
        margin-top: -20px;
        margin-bottom: 20px;
        border-bottom: 2px solid #f1f4f9;
        padding: 20px;

    }



</style>
